import { Dropdown } from "react-bootstrap"
import SvgUpload from "../svg/SvgUpload";
import { SolarCodeSquareBoldDuotone } from "../icons/SolarCodeSquareBoldDuotone";
import { SolarChatSquareCodeBoldDuotone } from "../icons/SolarChatSquareCodeBoldDuotone";
import OffCanvasCodeEditor from "../others/OffCanvasCodeEditor";
import { useState } from "react";

const ExpertDropdown = () => {

    const [ show, setShow ] = useState(false);

    return ( 
        <>
        <div className="pc-h-item ExpertDropdown">     
            <Dropdown>
                <Dropdown.Toggle
                        as="span"
                        className="pc-head-link ms-0 cursor-pointer">
                    <SolarChatSquareCodeBoldDuotone  />
                </Dropdown.Toggle>

                <Dropdown.Menu >
                    <Dropdown.Item onClick={()=>setShow('css')}>
                        <i className="bi bi-filetype-css text-muted"></i>CSS
                    </Dropdown.Item>
                    <Dropdown.Item onClick={()=>setShow('js')}>
                        <i className="bi bi-filetype-js text-muted"></i>JavaScript
                    </Dropdown.Item>

                </Dropdown.Menu> 
            </Dropdown>
        </div>

        <OffCanvasCodeEditor show={show}
            setShow={setShow}/>
        </>)
}
 
export default ExpertDropdown;